module.exports = __webpack_public_path__ + "static/media/bernards.6d665006.png";